import { Button, Modal, message, Input } from 'antd'
import _ from 'lodash'
import React from 'react'
import { app, use, api } from 'xadmin'
import { Form } from 'xadmin-form'
import { C } from 'xadmin-ui'
import { EyeInvisibleOutlined, EyeTwoTone } from '@ant-design/icons';
import { SchemaForm } from 'xadmin-form';
import sha1 from 'crypto-js/sha1'

const PasswordHolder = props => {
  const { input: { value, onChange } } = props
  const handleChagne = e => { onChange(e.target.value) }
  const tips = (/^(?![^a-zA-Z]+$)(?!\D+$)/ig.test(value) ? <span></span> : '密码必须为字母与数字组合')

  return <span>
    <Input.Password type="password" onChange={handleChagne} value={value} placeholder={props?.placeholder ? props?.placeholder : ''}
      iconRender={(visible) => (visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />)} />
    {/* <div style={{ color: '#ff4d4f', fontSize: 12 }}>{tips}</div> */}
  </span>
}

const ChangePasswordModal = props => {
  const { user } = use('redux', state => ({ user: state.user }))
  const { settings } = use('settings')
  const { form } = use('form')
  const schema = {
    type: 'object',
    properties: {
      password: {
        title: '新密码',
        type: 'string',
        maxLength: 30,
        minLength: 6,
        fieldType: 'password'
      },
      password2: {
        title: '重复密码',
        type: 'string',
        maxLength: 30,
        minLength: 6,
        fieldType: 'password'
      }
    },
    form: [{
      key: 'password',
      attrs: { type: 'password' },
      validate: value => {
        const username = form.getState().values?.name
        const nousername = settings.userExpand?.nousername
        if (value) {
          if (value.length < 6) return '密码不能少于6位';
          if (value.length > 30) return '密码不能多于30位';

          if (nousername && value.includes(username)) {
            return '密码不能包含用户名';
          }
        }
        return (/^(?![^a-zA-Z]+$)(?!\D+$)/ig.test(value) ? null : '密码必须为字母与数字组合')
      }
    }, {
      key: 'password2',
      attrs: { type: 'password' },
      validate: (value, { password }) => {
        if (value) {
          if (value.length < 6) return '密码不能少于6位';
          if (value.length > 30) return '密码不能多于30位';
        }
        return value == password ? ((/^(?![^a-zA-Z]+$)(?!\D+$)/ig.test(value) ? null : '密码必须为字母与数字组合')) : '两次输入密码不一致'
      }
    }]
  }

  const handleSubmit = async values => {

    try {
      await api(app.get('models').User).save({
        ...values, id: props.id, password: sha1(values.password).toString(),
        password2: sha1(values.password2).toString()
      }, true)
      message.success('修改密码成功')
      props.onClose()
      // 判断是否修改当前登录用户
      if (props?.id == user?.userId) {
        app.go('/login')
      }
    } catch (err) {
      return (err.formError || err.json)
    }
  }

  return (
    <SchemaForm
      formKey={'userChangePassword'}
      title="修改用户密码"
      saveText="修改密码"
      schema={schema}
      show={props.show}
      onSubmit={handleSubmit}
      onClose={props.onClose}
      component={C('Form.ModalLayout')}
    />
  )
}

const CheckPasswordModal = props => {
  const { user } = use('redux', state => { return { user: state.user } })

  const checkFields = [
    {
      name: 'password', required: true, label: '密码', attrs: { type: 'password' },
      description: '当前操作是危险操作，需谨慎操作', fieldType: 'password',
      // validate: value => {
      //   if(value) {
      //     if(value.length < 6) return '密码不能少于6位';
      //     if(value.length > 30) return '密码不能多于30位';
      //   }
      //   return (/^(?![^a-zA-Z]+$)(?!\D+$)/ig.test(value) ? null : '密码必须为字母与数字组合')
      // },
      component: props => <PasswordHolder {...props} placeholder="请输入当前登录用户的密码" />
    }
  ]

  const handleSubmit = async values => {
    try {
      await api({ name: `core/user/changepwd` }).fetch('', {
        method: 'POST', body: JSON.stringify({ password: sha1(values.password).toString() })
      }).then(res => {
        if (res.status == 200) {
          message.success('校验成功')
          props.getStatus(true)
        }
        props.onClose()
      }).catch(err => {
        // message.success('校验失败，密码不正确')
        props.getStatus(false)
      })
    } catch (err) {
      return (err.formError || err.json)
    }
  }

  return (
    <Form
      formKey="userChangePassword"
      title="密码校验"
      saveText="校验"
      show={props.show}
      onClose={props.onClose}
      fields={checkFields}
      onSubmit={handleSubmit}
      component={C('Form.ModalLayout')}
    />
  )
}

const PasswordField = ({ input }) => {
  const { formState: { values } } = use('form')
  const [show, setShow] = React.useState(false)
  const [check, setCheck] = React.useState(false)
 
  return values && values.id ? [(
    <Button onClick={() => setCheck(true)}>修改密码</Button>
  ), <CheckPasswordModal show={check} onClose={() => setCheck(false)} id={values.id} getStatus={(status) => { setShow(status) }}></CheckPasswordModal>,
  <ChangePasswordModal show={show} onClose={() => setShow(false)} id={values.id} />] : null
}

export default PasswordField
